import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import { RoleLevelDto } from '@/modules/system/auth/domain/role-level.dto';

export const PERMISSOES_CADASTRO_PESSOAS_LEITURA: RoleLevelDto[] = [
  { role: RoleEnum.PESSOA, level: PermissionEnum.READ },
  { role: RoleEnum.DEFENSOR, level: PermissionEnum.READ },
  { role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ },
  { role: RoleEnum.COLABORADOR, level: PermissionEnum.READ },
];

export const PERMISSOES_CADASTRO_PESSOAS_CRIACAO: RoleLevelDto[] = [
  { role: RoleEnum.PESSOA, level: PermissionEnum.CREATE },
  { role: RoleEnum.DEFENSOR, level: PermissionEnum.CREATE },
  { role: RoleEnum.ESTAGIARIO, level: PermissionEnum.CREATE },
  { role: RoleEnum.COLABORADOR, level: PermissionEnum.CREATE },
];

export const PERMISSOES_CADASTRO_PESSOAS_EDICAO: RoleLevelDto[] = [
  { role: RoleEnum.PESSOA, level: PermissionEnum.UPDATE },
  { role: RoleEnum.DEFENSOR, level: PermissionEnum.UPDATE },
  { role: RoleEnum.ESTAGIARIO, level: PermissionEnum.UPDATE },
  { role: RoleEnum.COLABORADOR, level: PermissionEnum.UPDATE },
];
